<script setup>
import { BUTTON_VARIANTS } from '@/utils/components-configurations/app-button'

import AppButtonNext from '@/components/ui/AppButtonNext/AppButtonNext'

defineOptions({
  name: 'ConfluenceMacroSettingsModalFooter'
})

const emit = defineEmits({
  cancel: null,
  save: null
})

defineProps({
  disableSaveButton: {
    type: Boolean
  }
})
</script>

<template>
  <div class="cms-Footer">
    <AppButtonNext :variant="BUTTON_VARIANTS.SECONDARY_GRAY" @click="emit('cancel')">
      {{ $t('action.cancel') }}
    </AppButtonNext>

    <AppButtonNext :disabled="disableSaveButton" @click="emit('save')">
      {{ $t('action.save') }}
    </AppButtonNext>
  </div>
</template>

<style lang="scss" scoped>
.cms-Footer {
  padding: 20px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  align-self: flex-end;
  width: 100%;
  border-top: 1px solid $grey-2-next;
  position: sticky;
  background: $white;
  z-index: 999999;
  bottom: 0;
}
</style>
